document.addEventListener("alpine:init", () => {
  Alpine.data("Theme_MenuDrawer", () => ({
    navLevel: 1,
    contents: {
      "1": {},
      "2": {},
      "3": {}
    },
    navLinkClick(contentKey, title) {
      var navLevel = this.navLevel + 1;
      this.contents[navLevel.toString()] = { key: contentKey, title: title };
      console.log(this.contents);
      this.navLevel = navLevel;
    },
    navPrevClick(evt) {
      var navLevel = this.navLevel - 1;
      this.contents[this.navLevel.toString()] = { key: null, title: null };
      this.navLevel = navLevel;
    },
    navLocaleOptionClick(evt) {
      const form = sectionContainer.querySelector("#nav-localization-form");
      var option = evt.srcElement.getAttribute("nav-locale-option");
      form
        .querySelector('[name="' + option + '"]')
        .setAttribute("value", evt.srcElement.getAttribute("value"));
      form.submit();
    },
    init() {
      if (Shopify.designMode) {
        this._setUpDesignMode();
      }
    },
    _setUpDesignMode() {
      document.addEventListener(
        "shopify:section:select",
        this._sectionSelectedHandler.bind(this)
      );

      document.addEventListener(
        "shopify:section:deselect",
        this._sectionDeselectedHandler.bind(this)
      );

      document.addEventListener(
        "shopify:section:unload",
        this._sectionUnloadHandler.bind(this)
      );
    },
    _sectionSelectedHandler(e) {
      if (!e.target.contains(this.$root)) return;

      Alpine.store("modals").open("sidebar");
    },
    _sectionDeselectedHandler(e) {
      if (!e.target.contains(this.$root)) return;

      Alpine.store("modals").close("sidebar");
    },
    _sectionUnloadHandler(e) {
      if (!e.target.contains(this.$root)) return;

      document.removeEventListener(
        "shopify:section:select",
        this._sectionSelectedHandler
      );
      document.removeEventListener(
        "shopify:section:deselect",
        this._sectionDeelectedHandler
      );
      document.removeEventListener(
        "shopify:section:unload",
        this._sectionUnloaHandler
      );
    },
  }));
  
  Alpine.store('menuDrawer', {
    domContentLoaded: false,
    show: false,
    open(evt) {
      console.log('menuDrawer', 'open');
      this.show = true;
    },
    close(evt) {
      console.log('menuDrawer', 'close');
      this.show = false;
    }
  });
});
